<template>
    <az-container class="movimentacaoBaixaListagemTabela mt-0">
        <az-form >
            <v-data-table
                :headers="colunas"
                ref="itemTabela"
                :loading="false"
                :items="itens"
                :options.sync="paginacaoInterna"
                :server-items-length="totalItens"
                @click:row="tratarClick"
                class="az-table-list az-table-list-access tabela-movimentacao-baixa"
                hide-default-footer
                must-sort
                no-data-text="Não há movimentações">
                <template v-slot:header.codigo>
                    Código
                </template>
                <template v-slot:item.dataCadastro="{item}">
                    {{ item.dataCadastro | azDate() }}
                </template>
                <template v-slot:item.tipo="{item}">
                    {{ item.tipo | azEnum(tipoMovimentacao) }}
                </template>
                <template v-slot:item.situacao="{item}">
                    <div v-if="ehSituacaoEmElaboracao(item)">
                      <v-icon x-small color="#FF9F1A" left class="mb-1">fas fa-edit</v-icon> {{ item.situacao | azEnum(situacaoMovimentacao) }}
                    </div>
                    <div v-else>
                        {{ item.situacao | azEnum(situacaoMovimentacao) }}
                    </div>
                </template>
                <template v-slot:item.colunaEscondida="{  }">
                    <v-icon>keyboard_arrow_right</v-icon>
                    <span class="mobile">Acessar</span>
                </template>
            </v-data-table>
            <div class="az-pagination">
                <v-pagination
                    v-if="paginas > 1"
                    v-model="paginacaoInterna.page"
                    :length="paginas"
                    next-icon="fas fa-chevron-right"
                    prev-icon="fas fa-chevron-left"/>

                <v-spacer v-if="paginas <= 1"/>

                <div class="az-select-pagination">
                    <span>Linhas por página:</span>
                    <v-select :items="linhasPorPagina" @change="resetaPage" v-model="paginacaoInterna.rowsPerPage"/>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
    import {mutationTypes} from '@/core/constants'
    import {mapMutations} from 'vuex'

    export default {
        name: 'MovimentacaoBaixaListagemTabela',
        props: {
            itens: {
                required: true,
                type: Array,
                default: () => {
                    return []
                }
            },
            paginacao: {
                required: true,
                type: Object
            },
            paginas: {
                required: true,
                type: Number,
                default: 0
            },
            totalItens: {
                required: true,
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                colunas: [
                    {
                        text: 'Código',
                        value: 'codigo',
                        sortable: true,
                        align: 'left',
                        width: '15%',
                        class: 'black--text'
                    },
                    {
                        text: 'Criado em',
                        value: 'dataCadastro',
                        sortable: true,
                        align: 'left',
                        width: '15%',
                        class: 'black--text'
                    },
                    {
                        text: 'Tipo',
                        value: 'tipo',
                        sortable: true,
                        align: 'left',
                        width: '20%',
                        class: 'black--text'
                    },
                    {
                        text: 'Órgão',
                        value: 'orgaoOrigem',
                        sortable: true,
                        align: 'left',
                        width: '20%',
                        class: 'black--text'
                    },
                    {
                        text: 'Situação',
                        value: 'situacao',
                        sortable: true,
                        align: 'left',
                        width: '25%',
                        class: 'black--text'
                    },
                    {
                        text: '',
                        value: 'colunaEscondida',
                        sortable: false,
                        align: 'center',
                        width: '5%',
                        class: 'black--text'
                    },
                ],
                paginacaoInterna: this.paginacao,
                linhasPorPagina: [10, 25, 50, 100]
            }
        },
        watch: {
            paginacaoInterna: {
                handler(novoValor) {
                    this.$emit('paginar', novoValor)
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations([
                mutationTypes.MOVIMENTACAO.BAIXA.RESETA_PAGE_BUSCAR_TODAS_MOVIMENTACOES_BAIXAS
            ]),
            ehSituacaoEmElaboracao(item) {
                return item.situacao === 'EM_ELABORACAO'
            },
            resetaPage() {
                this.resetaPageBuscarTodasMovimentacoesBaixas()
            },
            tratarClick(item) {
                this.$emit('acessar', item)
            }
        }
    }
</script>
<style lang="stylus">
    .movimentacaoBaixaListagemTabela
        .az-table-list tbody tr
            cursor pointer !important

        tbody td
            padding 0 10px !important

        .tabela-movimentacao-baixa
            min-height 62vh !important

    @media (max-width: 720px)
        .tabela-movimentacao-baixa
            .mobile
                display inline-block
                margin-left 3px

        .v-data-table__mobile-table-row
            cursor pointer !important

</style>
